(function() {
  function initHeroSlider(slider) {
    const slides = Array.from(slider.querySelectorAll('.hero-slider__slide'));
    if (slides.length <= 1) return;

    const ticks = Array.from(slider.querySelectorAll('.hero-slider__tick'));
    const prevBtn = slider.querySelector('.hero-slider__arrow--prev');
    const nextBtn = slider.querySelector('.hero-slider__arrow--next');
    const counterCurrent = slider.querySelector('.hero-slider__counter-current');
    
    // Create aria-live region for screen reader announcements
    let liveRegion = slider.querySelector('.hero-slider__live-region');
    if (!liveRegion) {
      liveRegion = document.createElement('div');
      liveRegion.className = 'hero-slider__live-region';
      liveRegion.setAttribute('aria-live', 'polite');
      liveRegion.setAttribute('aria-atomic', 'true');
      liveRegion.className = 'visually-hidden';
      slider.appendChild(liveRegion);
    }
    
    let currentIndex = 0;
    let timer = null;
    let isPaused = false;
    let pauseTimeout = null;
    
    const autoplaySeconds = parseFloat(slider.dataset.autoplay) || 6;
    const autoplayMs = autoplaySeconds * 1000;
    
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function announceSlide(index) {
      const slideTitle = slides[index].querySelector('.hero-slider__title');
      if (liveRegion && slideTitle) {
        liveRegion.textContent = 'Slide ' + (index + 1) + ' of ' + slides.length + ': ' + slideTitle.textContent;
      }
    }

    function goToSlide(index) {
      if (index === currentIndex) return;
      
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      
      slides[currentIndex].classList.remove('is-active');
      slides[index].classList.add('is-active');
      
      if (ticks.length) {
        ticks[currentIndex].classList.remove('is-active');
        ticks[index].classList.add('is-active');
        ticks[currentIndex].setAttribute('aria-selected', 'false');
        ticks[index].setAttribute('aria-selected', 'true');
      }
      
      if (counterCurrent) {
        counterCurrent.textContent = String(index + 1).padStart(2, '0');
      }
      
      currentIndex = index;
      announceSlide(index);
    }

    function nextSlide() {
      goToSlide(currentIndex + 1);
    }

    function prevSlide() {
      goToSlide(currentIndex - 1);
    }

    function startTimer() {
      if (prefersReducedMotion) return;
      stopTimer();
      timer = setInterval(nextSlide, autoplayMs);
    }

    function stopTimer() {
      if (timer) clearInterval(timer);
    }

    function handleInteraction() {
      stopTimer();
      if (pauseTimeout) clearTimeout(pauseTimeout);
      pauseTimeout = setTimeout(() => {
        startTimer();
      }, Math.max(6000, autoplayMs));
    }

    // Click listeners
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        prevSlide();
        handleInteraction();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        nextSlide();
        handleInteraction();
      });
    }

    ticks.forEach((tick, idx) => {
      tick.addEventListener('click', () => {
        goToSlide(idx);
        handleInteraction();
      });
    });

    // Keyboard navigation
    slider.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        prevSlide();
        handleInteraction();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        nextSlide();
        handleInteraction();
      }
    });

    // Touch/swipe support
    let touchStartX = 0;
    let touchEndX = 0;
    const swipeThreshold = 50;

    slider.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    slider.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      const diff = touchStartX - touchEndX;
      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          nextSlide();
        } else {
          prevSlide();
        }
        handleInteraction();
      }
    }, { passive: true });

    // Pause on hover (desktop)
    slider.addEventListener('mouseenter', () => {
      if (!prefersReducedMotion) stopTimer();
    });
    slider.addEventListener('mouseleave', () => {
      if (!prefersReducedMotion) startTimer();
    });

    // Initialize
    if (ticks.length) {
      ticks.forEach((t, i) => t.setAttribute('aria-selected', i === 0 ? 'true' : 'false'));
    }
    startTimer();
    
    slider.heroSliderAPI = {
      destroy: () => {
        stopTimer();
        if (pauseTimeout) clearTimeout(pauseTimeout);
      }
    };
  }

  function initAll() {
    document.querySelectorAll('.hero-slider').forEach(slider => {
      if (!slider.heroSliderAPI) {
        initHeroSlider(slider);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', (e) => {
    const slider = e.target.querySelector('.hero-slider');
    if (slider) {
      initHeroSlider(slider);
    }
  });
})();